import styled from 'styled-components';
import { Card } from 'antd';


export const AccountCard = styled(Card)`
	width: 100%!important;
	border-radius: 4px!important;
	margin-bottom: 4px!important;
	.ant-card-body {
		padding: 10px 10px 0 10px!important;
		transition: all 0.3s;
	}
	label {
		display: block;
		cursor: pointer;
	}
`;